
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 87.5 87.5"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M81.77 58.31a3.22 3.22 0 01-3.22 3.22h-11V27.95a7.82 7.82 0 00-7.81-7.81H26.07V9.07a3.22 3.22 0 013.22-3.21h49.23a3.22 3.22 0 013.25 3.21zm-22.2 23.33H7.77a2 2 0 01-1.95-2V27.95a2 2 0 011.95-2h51.8a1.95 1.95 0 012 1.95v51.79a2 2 0 01-.57 1.38 1.94 1.94 0 01-1.38.57zM78.42 0H29.29a9.08 9.08 0 00-9.08 9.07v11.05H7.77A7.81 7.81 0 000 27.95v51.74a7.82 7.82 0 007.77 7.81h51.8a7.82 7.82 0 007.81-7.81v-12.3h11a9.09 9.09 0 009.08-9.08V9.07A9.09 9.09 0 0078.38 0z"}}),_c('path',{attrs:{"d":"M46.77 59.67h-26a2.93 2.93 0 100 5.86h25.88a3 3 0 003-2.71 2.93 2.93 0 00-2.92-3.15zm0-17.58h-26a3 3 0 00-3 2.71 2.93 2.93 0 003 3.15h25.88a3 3 0 003-2.71 2.93 2.93 0 00-2.92-3.15z"}})])
          )
        }
      }
    